import { useRef, useEffect } from "react";

import "./LoadingSpinner.css";

import createAnimation from "../../_utils/createAnimation";

const LoadingSpinner = () => {
  const ref = useRef(null);

  useEffect(() => createAnimation(ref), []);

  return (
    <div className="LoadingSpinner" ref={ref}>
      <div className="LoadingSpinner-container">
        <div className="lds-default">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <p>Loading...</p>
      </div>
    </div>
  )
}

export default LoadingSpinner